import styled from "styled-components";
import { Link } from '../';
export const LinkDelete = styled(Link)`
  color: ${props => props.theme.colors.linkDeleteDefault};
  &:hover, &:focus {
    color: ${props => props.theme.colors.linkDeleteHover};
  }
`;
export const LinkDeleteReverse = styled(Link)`
  color: #ffffff;
  &:hover, &:focus {
    color: #ffffff;;
  }
`;